import { initialOggiMessages } from "./fixtures/oggi";

export type OggiRole = "assistant" | "user";

export type OggiOpportunity = {
  title: string;
  organization: string;
  deadline: string;
  budget: string;
};

export type OggiMessage = {
  id: string;
  role: OggiRole;
  content: string;
  createdAt: string;
  opportunity?: OggiOpportunity;
};

export type ImprovedOggiPrompt = {
  original: string;
  improved: string;
  isDemo: true;
};

export type OggiConversationPreview = "vuota" | "errore";

const wait = (milliseconds: number) =>
  new Promise<void>((resolve) => window.setTimeout(resolve, milliseconds));

export async function getOggiConversation(preview?: OggiConversationPreview): Promise<OggiMessage[]> {
  await wait(500);
  if (preview === "errore") throw new Error("La conversazione demo non è disponibile in questo momento.");
  if (preview === "vuota") return [];
  return initialOggiMessages.map((message) => ({ ...message }));
}

export async function sendOggiMessage(content: string, options: { retry?: boolean } = {}): Promise<OggiMessage> {
  await wait(850);
  if (content.toLowerCase().includes("errore") && !options.retry) {
    throw new Error("La risposta demo non è disponibile in questo momento.");
  }
  return {
    id: `reply-${Date.now()}`,
    role: "assistant",
    content: `Per il Comune di Gallinaro, ho ricevuto la richiesta “${content}”. Questa risposta è dimostrativa: verifica sempre bandi, requisiti e scadenze sulle fonti ufficiali.`,
    createdAt: new Date().toISOString(),
  };
}

export async function improveOggiPrompt(content: string): Promise<ImprovedOggiPrompt> {
  await wait(650);
  const trimmedContent = content.trim();
  return {
    original: trimmedContent,
    improved: `Per il Comune di Gallinaro, ${trimmedContent.replace(/[.!?]+$/, "")}: indica le opportunità più pertinenti, i requisiti principali e la prossima azione consigliata.`,
    isDemo: true,
  };
}
